import { useNavigate } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import styles from './Organizations.module.scss';
import { useOrganizations } from '../../api/hooks';
import PropTypes from 'prop-types';

const OrganizationCard = ({ org }) => {
  return (
    <div className={styles.organizationCard}>
      {org.logo && (
        <div className={styles.logoContainer}>
          <img src={org.logo} alt={`${org.name} logo`} className={styles.logo} />
        </div>
      )}
      <div className={styles.organizationInfo}>
        <h3>{org.name}</h3>
        <p className={styles.idNumber}>ID: {org.idNumber}</p>
        {org.parentOrganizationId && (
          <p className={styles.parentOrg}>Parent Organization ID: {org.parentOrganizationId}</p>
        )}
        <span className={styles.status}>
          Status: {org.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
    </div>
  );
};

OrganizationCard.propTypes = {
  org: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    idNumber: PropTypes.string,
    logo: PropTypes.string,
    parentOrganizationId: PropTypes.string,
    isActive: PropTypes.bool,
  }).isRequired,
};

const Organizations = () => {
  const navigate = useNavigate();
  const { data: response, isLoading, error } = useOrganizations();

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <p>Loading organizations...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <p>Error loading organizations: {error.message}</p>
      </div>
    );
  }

  const organizations = response?.data || [];

  return (
    <div className={styles.organizationsContainer}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <h2>Organizations</h2>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/organizations/create')}
          sx={{ minWidth: 200 }}
        >
          Crear Organización
        </Button>
      </Box>
      <div className={styles.organizationsGrid}>
        {organizations.map((org) => (
          <div key={org.id} className={styles.organizationCard}>
            {org.logo && (
              <div className={styles.logoContainer}>
                <img src={org.logo} alt={`${org.name} logo`} className={styles.logo} />
              </div>
            )}
            <div className={styles.organizationInfo}>
              <h3>{org.name}</h3>
              <p className={styles.idNumber}>ID: {org.idNumber}</p>
              {org.parentOrganizationId && (
                <p className={styles.parentOrg}>Parent Organization ID: {org.parentOrganizationId}</p>
              )}
              <span className={styles.status}>
                Status: {org.isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Organizations; 